<script lang="ts">
	import type { Snippet } from 'svelte';

	interface Props {
		margin?: boolean;
		smallGaps?: boolean;
		class?: string;
		children?: Snippet;
	}

	let { margin = true, smallGaps = false, class: className, children }: Props = $props();
</script>

<div
	class={[
		className,
		'grid grid-cols-4 gap-x-2 lg:grid-cols-12',
		{
			'lg:gap-x-12': !smallGaps,
			'lg:gap-x-[18px]': smallGaps,
			'max-sm:mx-4 sm:max-lg:mx-8': margin
		}
	]}
>
	{@render children?.()}
</div>
